import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { usePricing } from '../contexts/PricingContext';
import { ContactFormPopup } from './ContactFormPopup';
export function HeroVariant40() {
  const {
    language
  } = useLanguage();
  const {
    price
  } = usePricing();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const content = {
    ru: {
      title1: 'Сделаем сайт для вас бесплатно.',
      title2: `Обслуживание — ${price}/мес.`,
      sub: `Мы делаем сайт за свой счёт. Вы смотрите, просите правки, утверждаете. Когда всё нравится — платите ${price} в месяц за хостинг и поддержку. Не понравится — просто уходите. Без оплаты.`,
      cta: 'Получить бесплатный макет'
    },
    ua: {
      title1: 'Зробимо сайт для вас безкоштовно.',
      title2: `Обслуговування — ${price}/міс.`,
      sub: `Ми робимо сайт за свій рахунок. Ви дивитеся, просите правки, затверджуєте. Коли все подобається — платите ${price} на місяць за хостинг та підтримку. Не сподобається — просто йдете. Без оплати.`,
      cta: 'Отримати безкоштовний макет'
    },
    en: {
      title1: 'We build your website for free.',
      title2: `Maintenance — ${price}/mo.`,
      sub: `We build the site at our expense. You review, request edits, and approve. When you love it, you pay ${price}/month for hosting and support. Don't like it? Just walk away. No charge.`,
      cta: 'Get a free mockup'
    }
  }[language] || content.ru;
  return <>
      <section className="relative w-full pt-28 pb-12 px-4 flex items-center justify-center min-h-screen" style={{
      backgroundColor: 'var(--bg-primary)'
    }} data-id="element-641">
        {/* Full Rounded Video Container */}
        <div className="relative w-full max-w-[96%] h-[85vh] rounded-[2.5rem] overflow-hidden shadow-2xl flex items-center justify-center" data-id="element-642">
          <video src="https://cdn.magicpatterns.com/uploads/vrXe21wkVqS62d5BzpZ9eJ/original-2de319f4767c5a0d4acf4f107b938504.mp4" autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover" data-id="element-643" />

          {/* Dark Overlay for readability */}
          <div className="absolute inset-0 bg-black/30" data-id="element-644" />

          {/* Centered Glassmorphism Card */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="relative z-10 bg-white/10 backdrop-blur-xl border border-white/20 p-8 md:p-12 rounded-3xl text-center max-w-3xl mx-4 shadow-2xl" data-id="element-645">
            <h1 className="mb-4 text-3xl md:text-5xl lg:text-6xl font-black leading-tight text-white tracking-tight" data-id="element-646">
              {content.title1}
            </h1>
            <h2 className="mb-6 text-2xl md:text-3xl font-bold text-blue-300" data-id="element-647">
              {content.title2}
            </h2>
            <p className="text-base md:text-lg mb-10 text-gray-200 font-medium leading-relaxed max-w-2xl mx-auto" data-id="element-648">
              {content.sub}
            </p>
            <button onClick={() => setIsPopupOpen(true)} className="group inline-flex items-center justify-center gap-2 rounded-full px-10 py-4 font-bold text-lg transition-all hover:scale-105 bg-white text-gray-900 hover:bg-gray-100" data-id="element-649">
              {content.cta}
              <ArrowRightIcon className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-650" />
            </button>
          </motion.div>
        </div>
      </section>
      <ContactFormPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} data-id="element-651" />
    </>;
}